import React, { useState } from 'react';
import { SwipeableDrawer } from '@mui/material';
import AppBar from 'sections/AppBar';
import Menu from 'sections/Menu';
import isMobile from 'utils/isMobile';

function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuOpen = () => {
    setIsMenuOpen(true);
  };

  const handleMenuClose = () => {
    setIsMenuOpen(false);
  };
  
  return (
    <>
      {isMobile ? (
        <SwipeableDrawer
          anchor="right"
          open={isMenuOpen}
          onClose={handleMenuClose}
          onOpen={handleMenuOpen}
        >
          <Menu onClose={handleMenuClose} />
        </SwipeableDrawer>
      ) : (
        <>
          <Menu isOpen={isMenuOpen} onClose={handleMenuClose} onOpen={handleMenuOpen} />
          <AppBar isMenuOpen={isMenuOpen} onMenuOpen={handleMenuOpen} />
        </>
      )}
    </>
  );
}

export default Navigation;
